import { render, staticRenderFns } from "./IndexSlider.vue?vue&type=template&id=45067eaa&scoped=true&"
import script from "./IndexSlider.vue?vue&type=script&lang=ts&"
export * from "./IndexSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45067eaa",
  null
  
)

export default component.exports